// extracted by mini-css-extract-plugin
export default {"Main":"StickyAlert_Main__YS3rj","Link":"StickyAlert_Link__aaa+H","CloseButton":"StickyAlert_CloseButton__9yQqu"};